<!--  新电表  电量使用记录 -->
<template>
  <table-view :total="total" :query-info.sync="queryInfo" @reload-table="renderTable">
    <template #header>
      <div class="header-button mb-1">
        <el-tag class="successNum">数据最新更新时间：{{ newsTime }}</el-tag>
        <el-tag class="successNum">剩余电量：{{ newsBalance }}</el-tag>
      </div>
    </template>
    <el-table :data="tableData" class=" mt-1" style="width: 100%" border stripe>
      <el-table-column type="index" label="ID" width="50" />
      <el-table-column prop="startDate" label="开始时间" />
      <el-table-column prop="endDate" label="结束时间" />
      <el-table-column prop="useNumber" label="已用电量" />
      <el-table-column prop="balance" label="剩余电量" />
    </el-table>
  </table-view>
</template>

<script>
import tableView from '@/vue/mixins/table-view'
import { pageNewElectricMeterApi } from '@/api/dorm/set-electric-meter-api'

export default {
  name: 'NewElectricityBillRecords',
  mixins: [tableView],
  props: {
    parentData: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      queryInfo: {
        roomId: null,
        pageSize: 10
      },
      newsTime: null,
      newsBalance: null,
      initFlag: false
    }
  },
  mounted() {
    this.renderTable(1)
  },
  methods: {
    async renderTable(pageNum) {
      if (this.parentData.meterNumber) {
        this.queryInfo.roomId = this.parentData.id
      } else {
        return this.$message.info('该宿舍暂未绑定电表')
      }
      await this.getTableData(pageNewElectricMeterApi, pageNum)
      if (!this.initFlag && this.tableData.length) {
        this.newsTime = this.tableData[0].endDate
        this.newsBalance = this.tableData[0].balance
        this.initFlag = true
      }
    }
  }

}
</script>

<style lang="scss" scoped>
.successNum {
  margin: 5px 20px 0 0;
}
</style>
